import { createSlice } from "@reduxjs/toolkit";

const GrowerReducer = createSlice({
  name: "GrowerReducer",
  initialState: {
     qrInfo: {},
  },
  reducers: {
    setField(state, action) {
      state[action.payload.name] = action.payload.value;
    },
    
  },
});

export const {
  setField,
   
} = GrowerReducer.actions;
export default GrowerReducer.reducer;
